(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-site-styles"] && !Shopify.designMode) return;
  try {
    
  /* mp-cart-sync: engraving fee + cart add-on buttons (2026-10-09). */
  (function () {
    if (window.__mpCartSync) return;
    window.__mpCartSync = true;

    var cfg = document.querySelector('[data-mp-cart-sync]');
    var FEE = cfg ? Number(cfg.dataset.engraveFee) || 0 : 0;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var eventsMod = import('@shopify/events').catch(function () { return null; });
    var busy = false, again = false, pending = null;

    function isEngraved(item) {
      var p = item.properties || {};
      return Object.keys(p).some(function (k) { return /^Engraving line \d/.test(k) && String(p[k] || '').trim() !== ''; });
    }

    // Set cart quantities by variant id ({id: qty}); Horizon re-renders the drawer, cart page and bubble.
    async function setQty(updates) {
      var ev = await eventsMod;
      var deferred = ev ? ev.CartLinesUpdateEvent.createPromise() : null;
      var sections = Array.from(document.querySelectorAll('cart-items-component'))
        .map(function (c) { return c.dataset.sectionId; }).filter(Boolean);
      if (ev) {
        document.dispatchEvent(new ev.CartLinesUpdateEvent({
          action: 'update', context: 'cart',
          lines: Object.keys(updates).map(function (id) { return { merchandiseId: String(id), quantity: updates[id] }; }),
          promise: deferred.promise
        }));
      }
      try {
        var r = await fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates, sections: sections.join(','), sections_url: location.pathname })
        });
        var res = await r.json();
        if (!r.ok || res.status) throw new Error(res.description || res.message || 'Cart update failed');
        if (deferred) deferred.resolve({
          cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(res),
          detail: { items: res.items, itemCount: res.item_count, sections: res.sections || {}, source: 'mp-cart-sync', didError: false }
        });
        return res;
      } catch (e) {
        if (deferred) deferred.reject(e);
        throw e;
      }
    }

    // One "Personalized Engraving" unit per engraved bottle, never more, never less.
    function syncFee() {
      if (!FEE) return Promise.resolve();
      if (busy) { again = true; return pending; }
      busy = true;
      pending = (async function () {
        try {
          var cart = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (x) { return x.json(); });
          var need = 0, have = 0;
          cart.items.forEach(function (it) {
            if (it.variant_id === FEE) have += it.quantity;
            else if (isEngraved(it)) need += it.quantity;
          });
          if (need !== have) {
            var u = {}; u[FEE] = need;
            await setQty(u);
          }
        } catch (e) {
          console.warn('[mp-cart-sync]', e);
        } finally {
          busy = false;
          if (again) { again = false; syncFee(); }
        }
      })();
      return pending;
    }
    window.mpSyncEngravingFee = syncFee;

    eventsMod.then(function (ev) {
      if (!ev) return;
      document.addEventListener(ev.StandardEvents.cartLinesUpdate, function (e) {
        if (!e.promise) return;
        e.promise.then(function (res) {
          if (res && res.detail && res.detail.source === 'mp-cart-sync') return;
          syncFee();
        }).catch(function () {});
      });
    });
    if (cfg && Number(cfg.dataset.cartCount) > 0) syncFee();
    window.addEventListener('pageshow', function (e) { if (e.persisted) syncFee(); });

    // Never let checkout start while the fee is being corrected.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('button[name="checkout"], a[href$="/checkout"]');
      if (!btn || !busy || btn.dataset.mpWaited) return;
      e.preventDefault();
      e.stopPropagation();
      Promise.resolve(pending).then(function () { btn.dataset.mpWaited = '1'; btn.click(); delete btn.dataset.mpWaited; });
    }, true);

    if (!customElements.get('mp-cart-addons')) {
      customElements.define('mp-cart-addons', class extends HTMLElement {
        connectedCallback() {
          if (this._ready) return;
          this._ready = true;
          this.addEventListener('click', (e) => {
            var btn = e.target.closest('[data-mp-addon]');
            if (!btn || btn.disabled || this.getAttribute('aria-busy') === 'true') return;
            var id = btn.dataset.mpAddon;
            var on = btn.getAttribute('aria-pressed') === 'true';
            var updates = {};
            updates[id] = on ? 0 : 1;
            // Gift bag sizes are a choice: picking one removes the other.
            if (!on && btn.dataset.group) {
              this.querySelectorAll('[data-group="' + btn.dataset.group + '"][aria-pressed="true"]').forEach(function (o) {
                if (o !== btn) updates[o.dataset.mpAddon] = 0;
              });
            }
            this.setAttribute('aria-busy', 'true');
            setQty(updates).catch(function (err) { console.warn('[mp-cart-addons]', err); })
              .finally(() => this.removeAttribute('aria-busy'));
          });
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
